import { ApplicationTypes } from '@/models/ApplicationType';

export const sumActivityPoints = (activities: { points?: number | null }[] | null | undefined) =>
  (activities ?? []).reduce((total, activity) => total + (activity.points ?? 0), 0);

// portalOpen is keyed by application type, so it must be indexed — `!portalOpen` is always false.
export const isGrowthAwardPortalClosed = (
  portalOpen: { [key: number]: boolean } | null | undefined,
  canEdit: boolean
) => (portalOpen == null || portalOpen[ApplicationTypes.GrowthAward] === false) && !canEdit;
